/** to be replaced by compiler during build time */
export default '0.1.0-beta.52';
